<template>
  <div class="index">
    <div class="main">
      <img src="../assets/banner.png" alt />
      <div>
        <h3>项目介绍</h3>
        <p>PROJECT INTRODUCTION</p>
        <div class="proIntroduction">
          <div class="general">
            <div>
              <h3>中国儿童青少年积极发展调查及促进研究(CPYDS)</h3>
              <p>长期以来，“问题”和“缺陷”视角在儿童青少年研究和教育实践中一直起着主导的作用，由此带来了看待个体发展的不全面性。基于对这种视角的批评，积极青少年发展观提出所有青少年都具有积极成长与发展的潜在能力和可塑性，关注个体充分、成功的发展而不仅仅是减少问题行为，强调环境与个体的互动对青少年积极发展的重要作用。这种“缺陷观”到“优势观”的转变是近年来发展心理学领域理论与实证研究范式的重大变革，并产生了令人瞩目的成果。</p>
              <div>
                <a style="color:#fff" href="#/ProjectIntroduction/framework">点击查看更多>></a>
              </div>
            </div>
          </div>
          <div class="bigEvent">
            <p>
              <span>项目大事件</span>
              <a href="#/ProjectIntroduction/bigEvent">更多>></a>
            </p>
            <ul>
              <li v-for="(list,index) in ProjectEventList" v-bind:key="index">
                <a href="javascript:;" @click="EventDetails(list)" :title="list.Theme">{{list.Theme}}</a>
                <span>{{list.ReleaseTime_toString}}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div>
        <h3>数据中心</h3>
        <p>DATA CENTER</p>
        <div class="dataCenter">
          <Carousel
            :imgWidth="740"
            :imgList="imgList"
            :initIndex="0"
            :loop="true"
            :auto="true"
            :autoTime="2000"
          ></Carousel>
          <div class="dataText">
            <h3>
              <span>留守儿童积极发展追踪调查</span>
            </h3>
            <div>
              <p>在我国，农村留守儿童主要集中在中西部地区，如四川、安徽、湖南、河南、江西、湖北和贵州7省占比近70%。</p>
              <p>2017年10月到2018年6月，课题组根据我国各区县经济、教育、生活和社会文化上的差异，以分层四阶段方便取样的方式选取我国10个省份60所中小学的16317名9~20岁的儿童青少年开展了基线调查，其中农村留守儿童为1691人，对留守儿童所拥有的积极品格、能力、自信等积极资源进行了深度的调查。结果发现，在反映积极发展的重要资源和优势上，留守儿童总体发展处于中等偏上水平。</p>
              <p>2018年12月、2019年6月和2019年12月针对部分省份完成了基线调查基础上的三轮追踪调查。</p>
            </div>
            <h3>
              <b></b>
            </h3>
          </div>
        </div>
      </div>
      <div>
        <h3>文档中心</h3>
        <p>DOCUMENT CENTER</p>
        <div class="documentCenter">
          <div>
            <p>
              <span>项目主要发现</span>
              <a href="#/DocumentCenter/found">更多>></a>
            </p>
            <ul>
              <li v-for="(list,index) in ProjectFoundList" v-bind:key="index">
                <a href="javascript:;" @click="FindDetails(list)" :title="list.Theme">{{list.Theme}}</a>
              </li>
            </ul>
          </div>
          <div>
            <p>
              <span>政策建议与对策</span>
              <a href="#/DocumentCenter/advice">更多>></a>
            </p>
            <ul>
              <li>
                <a
                  href="http://news.gmw.cn/2019-10/25/content_33263047.htm"
                  target="_blank"
                  title="光明日报光明调查：深化新时代农村留守儿童关爱保护与发展工作"
                >光明日报光明调查：深化新时代农村留守儿童关爱保护与发展工作</a>
              </li>
              <li>
                <a
                  href="http://dzb.rmzxb.com/index.aspx?date=2019-02-20&verOrder=09&banzi=8&paperType=rmzxb"
                  target="_blank"
                  title="人民政协报：以_全人_角度看待留守儿童成长教育"
                >人民政协报：以_全人_角度看待留守儿童成长教育</a>
              </li>
              <li>
                <a :href="src1" target="_blank" title="促进我国青少年发展的新视角：积极青少年发展的框架与路径">促进我国青少年发展的新视角：积极青少年发展的框架与路径</a>
              </li>
              <li>
                <a :href="src2" target="_blank" title="流动儿童积极发展与心理健康状况评估报告">流动儿童积极发展与心理健康状况评估报告</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div>
        <h3>实践中心</h3>
        <p>PRACTICE CENTER</p>
        <div class="socialPractice">
          <div>
            <a href="#/PracticeCenter/growthThinking">
              <img src="../assets/social1.jpg" alt />
              <span>处境不利儿童心理弹性干预</span>
            </a>
          </div>
          <div>
            <a href="#/PracticeCenter/growthThinking">
              <img src="../assets/social2.jpg" alt />
              <span>儿童青少年成长型思维提升</span>
            </a>
          </div>
        </div>
      </div>
      <div>
        <h3 class="info">写信给我们</h3>
        <p>EMAIL TO US</p>
        <div class="information">
          <form action>
            <input type="text" placeholder="姓名" v-model="formMess.name" />
            <input type="text" placeholder="电话" v-model="formMess.phone" />
            <textarea placeholder="请输入内容" v-model="formMess.content"></textarea>
          </form>
          <div class="submit" @click="onSubmit()">点击提交</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Carousel from "./shuffling/carousel";
export default {
  name: "index",
  data() {
    return {
      src1: [require("../assets/pdf/4.3.pdf")],
      src2: [require("../assets/pdf/4.4.pdf")],
      formMess: {
        name: "",
        phone: "",
        content: ""
      },
      checkdata: [
        {
          inspect: "", // 待检测的字段
          msg: "姓名" // 空值返回的提示
        },
        {
          inspect: "",
          msg: "手机号",
          reg: "^[1][3,4,5,7,8][0-9]{9}$"
        },
        {
          inspect: "", // 待检测的字段
          msg: "姓名" // 空值返回的提示
        }
      ],
      ProjectEventList: [],
      ProjectFoundList: [],
      imgList: [
        {
          img: require("../assets/img1.jpg")
        },
        {
          img: require("../assets/img2.jpg")
        },
        {
          img: require("../assets/img3.jpg")
        },
        {
          img: require("../assets/img4.jpg")
        }
      ]
    };
  },
  mounted: function() {
    this.getData();
  },
  methods: {
    getData() {
      this.$axios({
        method: "post",
        url: "https://auth.zkey.cc/api/Notice/GetPublicList",
        headers: {
          "Content-Type": "application/json"
        },
        // withCredentials: true
        data: JSON.stringify({
          offset: 0,
          limit: 8,
          Type: "ProjectEvent"
        })
      })
        .then(res => {
          this.ProjectEventList = res.data.list;
        })
        .catch(function(error) {
          console.log(error);
        });
      this.$axios({
        method: "post",
        url: "https://auth.zkey.cc/api/Notice/GetPublicList",
        headers: {
          "Content-Type": "application/json"
        },
        // withCredentials: true
        data: JSON.stringify({
          offset: 0,
          limit: 4,
          Type: "ProjectFind"
        })
      })
        .then(res => {
          this.ProjectFoundList = res.data.list;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 判定是否合规
    have_empty(arr) {
      for (let key in arr) {
        if (arr[key].inspect && arr[key].reg) {
          // 有值并且有规则执行验证
          let reg = new RegExp(arr[key].reg);
          var rightEnd = reg.test(arr[key].inspect);
          if (!rightEnd) {
            this.$message({
              showClose: true,
              message: "请输入正确的" + arr[key].msg,
              type: "error"
            });
            return false;
          }
        } else if (!arr[key].inspect) {
          this.$message({
            showClose: true,
            message: "请输入" + arr[key].msg,
            type: "error"
          });
          return false;
        }
      }
      return true;
    },
    assignData() {
      var arrForm = [];
      for (let key in this.formMess) {
        arrForm.push(key);
      }
      for (let i = 0; i < this.checkdata.length; i++) {
        this.checkdata[i].inspect = this.formMess[arrForm[i]];
      }
    },
    onSubmit() {
      this.assignData();
      var end = this.have_empty(this.checkdata);
      if (!end) return; // 判定验证结果
      let formData = new FormData();
      for (var key in this.formMess) {
        formData.append(key, this.formMess[key]);
      }
      this.$axios({
        method: "post",
        url: "https://auth.zkey.cc/api/Message/XinLiSuoSendMail",
        headers: {
          "Content-Type": "application/json"
        },
        withCredentials: true,
        data: formData
      }).then(res => {
        if (res.status) {
          this.$message({
            showClose: true,
            message: "提交成功",
            type: "error"
          });
        } else {
          this.$message({
            showClose: true,
            message: "提交失败",
            type: "error"
          });
        }
      });
    },
    EventDetails(data) {
      this.listID = data.ID;
      window.location.href = "#/ProjectIntroduction/bigEvent?ID="+this.listID;
      // this.conIsShow = false
    },
    FindDetails(data) {
      this.listID = data.ID;
      window.location.href = "#/DocumentCenter/found?ID="+this.listID;
      // this.conIsShow = false
    }
  },
  components: {
    Carousel
  }
};
</script>
<style scoped>
.index > div {
  width: 80%;
  margin: 0 auto;
}
.main > img {
  max-width: 100%;
}
.main > div {
  display: inline-block;
  width: 100%;
  margin-bottom: 60px;
}
.main > div > h3 {
  font-size: 48px;
  color: #333;
  text-align: center;
  font-weight: normal;
}
.main > div > h3.info {
  color: #2dafd7;
}
.main > div > p {
  text-align: center;
  font-size: 30px;
  color: #999;
  margin-top: 12px;
  margin-bottom: 30px;
}
/* 项目介绍 */

.proIntroduction > div {
  display: inline-block;
  vertical-align: top;
}
/* 项目总体介绍 */
.general {
  width: 30%;
  border: solid 3px #a4ddf7;
  box-sizing: border-box;
}
.general > div > h3 {
  font-size: 20px;

  margin: 20px 0;
  color: #04a5d7;
  text-align: center;
}
.general > div > p {
  font-size: 16px;
  color: #666;
  text-indent: 2em;
  line-height: 30px;
  padding: 10px;
}
.general > div > div {
  color: #fff;
  background: #a4ddf7;
  padding: 10px;
  text-align: center;
  cursor: pointer;
  font-size: 18px;
  margin-top: 30px;
}
/* 项目大事件 */
.bigEvent {
  width: 68%;
  float: right;
}
.bigEvent > p {
  width: 100%;
  border-bottom: solid 2px #aaa;
  box-sizing: border-box;
  height: 40px;
  position: relative;
}
.bigEvent > p > span {
  bottom: -2px;
  width: 194px;
  border-bottom: solid 2px #a4ddf7;
  display: inline-block;
  left: 0;
  font-size: 32px;
  letter-spacing: -3px;
  position: absolute;
  line-height: 50px;
}
.bigEvent > p > a {
  color: #04a5d7;
  float: right;
  font-size: 24px;
  margin-top: 4px;
}
.bigEvent > ul {
  margin-top: 20px;
  width: 100%;
  min-height: 320px;
}
.bigEvent > ul > li {
  border-bottom: solid 1px #bfbfbf;
  margin-top: 10px;
  line-height: 34px;
}

.bigEvent > ul > li > span {
  font-size: 20px;
  color: #666;
  font-family: serif;
  float: right;
}
.bigEvent > ul > li > a {
  font-size: 20px;
  color: #333;
  display: inline-block;
  width: calc(100% - 130px);
  vertical-align: top;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 数据中心 */
.dataCenter > div {
  display: inline-block;
}
.dataText {
  width: 48%;
  float: right;
}
.dataText > h3 {
  width: 100%;
  border-bottom: solid 5px #ccc;
  position: relative;
  height: 36px;
}
.dataText > h3:last-child {
  height: 20px;
}
.dataText > h3 > span,
.dataText > h3 > b {
  font-size: 24px;
  display: inline-block;
  border-bottom: solid 5px #a4ddf7;
  font-weight: normal;
  color: #a4ddf7;
  line-height: 48px;
  position: absolute;
  bottom: -5px;
}
.dataText > h3 > b {
  width: 280px;
  right: 0;
}
.dataText > div {
  margin-top: 20px;
}
.dataText > div > p {
  font-size: 22px;
  color: #666;
  text-indent: 2em;
}
.dataText > div > p:nth-child(2) {
  margin: 32px 0;
}
/* 文档中心 */
.documentCenter > div {
  display: inline-block;
  width: 46%;
  margin: 0 2%;
  vertical-align: top;
}
.documentCenter > div:first-child {
  margin-left: 0;
}
.documentCenter > div:last-child {
  margin-right: 0;
}
.documentCenter > div > p {
  width: 100%;
  border-bottom: solid 5px #aaa;
  box-sizing: border-box;
  height: 40px;
  position: relative;
}
.documentCenter > div > p > span {
  bottom: -5px;
  width: 190px;
  border-bottom: solid 5px #7ecef4;
  display: inline-block;
  left: 0;
  font-size: 28px;
  letter-spacing: -3px;
  position: absolute;
  line-height: 40px;
  color: #7ecef4;
}
.documentCenter > div > p > a {
  color: #04a5d7;
  float: right;
  font-size: 22px;
}
.documentCenter > div > ul {
  margin-top: 20px;
  width: 100%;
  border-bottom: solid 3px #c9c9c9;
}
.documentCenter > div > ul > li {
  margin-top: 10px;
  line-height: 34px;
  font-size: 20px;
  color: #666;
  font-family: serif;
  list-style: square;
  list-style-position: inside;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 实践中心 */
.socialPractice {
  text-align: center;
}
.socialPractice > div {
  width: 48%;
  text-align: center;
  margin: 0 1%;
  display: inline-block;
}
.socialPractice > div:first-child {
  margin-left: 0;
}
.socialPractice > div:last-child {
  margin-right: 0;
}
.socialPractice > div > a > img {
  width: 100%;
  vertical-align: middle;
  margin-bottom: 50px;
}
.socialPractice > div > a > span {
  font-size: 48px;
  color: #333;
}
/* 信息提交 */
.information {
  width: 100%;
  max-width: 969px;
  margin: 0px auto;
}
.information form input,
.information form textarea {
  width: 100%;
  max-width: 961px;
  height: 101px;
  margin-bottom: 30px;
  border-radius: 10px;
  border: solid 4px #2baed7;
  text-indent: 1em;
  font-size: 30px;
  color: #333;
  border-radius: 50px;
  outline: none;
  resize: none;
}
.information form textarea {
  height: 429px;
  border-radius: 10px;
  line-height: 60px;
}
.submit {
  width: 70%;
  max-width: 636px;
  height: 97px;
  line-height: 97px;
  text-align: center;
  line-height: 97px;
  background-color: #2baed7;
  color: #fff;
  cursor: pointer;
  font-size: 48px;
  margin: 60px auto 0;
}

@media screen and (max-width: 1600px) {
  .main>div>h3,
  .socialPractice > div > a > span,
  .submit{
    font-size: 38px;
  }
  .main>div>p,
  .socialPractice > div > a > span,
  .bigEvent > p > span{
    font-size: 26px;
  }
  .general{
    width: 35%;
  }
  .general > div > h3{
    margin: 10px 0 0;
  }
  .general>div>div{
    margin-top: 10px;
  }
  .bigEvent{
    width: 63%;
  }
  .socialPractice > div > a > img{
    margin-bottom: 20px;
  }
  .main > div{
    margin-bottom: 40px;
  }
  
}
@media screen and (max-width: 1300px) {
  .main>div>h3,
  .submit{
    font-size: 30px;
  }
  .main>div>p,
  .bigEvent > p > span,
  .dataText > h3 > span,
  .documentCenter > div > p > span,
  .socialPractice > div > a > span,
  .information form input,
  .information form textarea{
    font-size: 22px;
  }
  .bigEvent > p > a,
  .documentCenter > div > p > a{
    font-size: 20px;
  }
  .general{
    width: 40%;
  }
  .bigEvent{
    width: 58%;
  }
  .dataText > div > p{
    font-size: 18px;
  }
  .dataText > div > p:nth-child(2){
    margin: 15px 0;
  }
  .dataText > h3,
  .dataText > h3 > span,
  .dataText > h3 > b,
  .documentCenter > div > p,
  .documentCenter > div > p > span,
  .information form input,
  .information form textarea{
    border-width: 2px;
    bottom: -2px;
  }
  .submit{
    height: auto;
    line-height: 2.5;
    margin: 20px auto 0;
  }
  .information form input{
    height: auto;
    line-height: 2.5;
  }
  .information form textarea{
    height: 200px;
  }
  .bigEvent > p > span,
  .documentCenter > div > p > span{
    letter-spacing: 0;
  }
  .main > div{
    margin-bottom: 30px;
  }
}

@media screen and (max-width: 1000px) {
  .index > div{
    width: 90%;
  }
  .submit{
    font-size: 24px;
  }
  .documentCenter > div > ul{
    margin-top: 10px;
  }
  .main > div{
    margin-bottom: 20px;
  }
  .general{
    width: 50%;
  }
  .bigEvent{
    width: 48%;
  }
  #swiper{
    border-width: 10px;
  }
}

@media screen and (max-width: 768px) {
  .main>div>h3{
    font-size: 24px;
  }
  .main>div>p,
  .bigEvent > p > span,
  .dataText > h3 > span,
  .documentCenter > div > p > span,
  .socialPractice > div > a > span,
  .information form input,
  .information form textarea{
    font-size: 18px;
  }
  .bigEvent > p > a,
  .documentCenter > div > p > a{
    font-size: 16px;
  }
  .documentCenter > div > ul > li{
    font-size: 16px;
    margin-top: 0;
  }
  #swiper,
  .proIntroduction > div,
  .dataCenter > div,
  .documentCenter > div,
  .socialPractice > div{
    display: block;
    width: 100%;
    margin: 0 0 20px;
  }
  #swiper{
    border-width: 5px;
  }
  .submit{
    font-size: 20px;
    margin: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue